<template>
    <div v-show="visible">
        <el-dialog title="修改" :visible.sync="visible" :close-on-click-modal="false"
            v-loading="loading"
            :before-close="dialogClose" width="360px">
            <el-form ref="form" :model="form" :rules="rules" label-width="80px">
                <el-form-item prop="deptId" label="学校">
                    <el-select v-model="form.deptId" placeholder="请选择学校" disabled>
                        <el-option
                            v-for="item in depts"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="cardNo" label="卡号">
                    <el-input v-model="form.cardNo" style="width:206px;" placeholder="请输入卡号" clearable maxlength="8" show-word-limit></el-input>
                </el-form-item>
                <el-form-item prop="status" label="状态">
                    <el-select v-model="form.status" placeholder="请选择状态">
                        <el-option :value="1" label="启用"></el-option>
                        <el-option :value="2" label="禁用"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取 消</el-button>
                <el-button type="primary" @click="save">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import http from '../../../../common/http';

    export default {
        data(){
            return{
                visible:false,
                loading:false,
                depts:[],
                form:{
                    id:"",
                    deptId:"",
                    cardNo:"",
                    status:1
                },
                rules:{
                    deptId: [
                        { required: true, message: '请选择学校', trigger: 'change' }
                    ],
                    cardNo: [
                        { required: true, message: '请输入卡号', trigger: 'blur' },
                        { min: 8, max: 8, message: '卡号长度必须为8位', trigger: 'blur' }
                    ],
                    status: [
                        { required: true, message: '请选择状态', trigger: 'change' }
                    ],
                }
            }
        },
        methods:{
            init(row, deptId){
                this.visible = true;
                this.loading = false;
                this.form = {
                    id: row && row.id ? row.id : "",
                    deptId: (row && row.deptId) ? row.deptId : (deptId || ""),
                    cardNo: row && row.cardNo ? row.cardNo : "",
                    status: row && row.status ? row.status : 1
                };
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                this.getDepts();
            },
            dialogClose(done){
                done();
                this.$parent.updateVisible = false;
            },
            getDepts(){
                let url  = this.listDeptUrl;
                let data = {parentId:"0"};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.depts=res.data.list;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            save(){
                this.$refs['form'].validate((valid) => {
                    if(!valid){
                        return;
                    }
                    this.loading=true;
                    let url = this.cardUpdateUrl;
                    let data = {
                        id: this.form.id,
                        deptId: this.form.deptId,
                        cardNo: this.form.cardNo,
                        status: this.form.status
                    };
                    this.apiPost(url,data).then((res)=>{
                        this.loading=false;
                        if(res.status == 200){
                            this.$commonFn.showTip(res.message,1);
                            this.visible=false;
                            this.$parent.updateVisible = false;
                            this.$parent.getData();
                        }else{
                            this.$commonFn.showTip(res.message,3);
                        }
                    },(err)=>{
                        console.log(err);
                        this.loading=false;
                    })
                });
            }
        },
        mixins: [http]
    }
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/page/sys/card/Update.vue